// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__24qQZ","rootCenter":"LoadMoreObserver_rootCenter__kSxmU","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2pb2_"};